var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreVert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "more_vert_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#more_vert_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.27c-.412 0-.766-.148-1.06-.441a1.445 1.445 0 01-.44-1.06c0-.412.147-.765.44-1.06.294-.293.648-.44 1.06-.44.412 0 .766.147 1.06.44.293.295.44.648.44 1.06 0 .413-.147.766-.44 1.06-.294.293-.648.44-1.06.44zm0-5.77c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 0110.5 12c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44.412 0 .766.147 1.06.44.293.294.44.648.44 1.06 0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44zm0-5.77c-.412 0-.766-.146-1.06-.44a1.444 1.444 0 01-.44-1.06c0-.412.147-.765.44-1.059.294-.293.648-.44 1.06-.44.412 0 .766.147 1.06.44.293.294.44.647.44 1.06 0 .412-.147.765-.44 1.06-.294.293-.648.44-1.06.44z",
    fill: "#fff"
  }))));
}
export default SvgMoreVert;